import { useMemo } from "react";
var useLinearProgress = function useLinearProgress(value) {
  return useMemo(function () {
    return {
      transform: "translateX(-".concat(100 - value, "%)")
    };
  }, [value]);
};
export default useLinearProgress;